exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width:1500px){.container-fluid[data-v-f3ea2f6e]{width:80%}}@media (min-width:2000px){.container-fluid[data-v-f3ea2f6e]{width:60%}}.lnk[data-v-f3ea2f6e]{cursor:pointer}.back-to-top[data-v-f3ea2f6e]{cursor:pointer;position:fixed;bottom:20px;right:20px;display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f3ea2f6e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/users/UserList.vue
// module id = 140
// module chunks = 0